import apiClient from "../api";

// export const adminLogin = (data) => apiClient.post("/admin/login", data);
export const adminLogin = (data) => apiClient.post("/admin/login", data);
export const changePassword = (data) =>
  apiClient.post("/admin/changePassword", data);
export const userList = (params = {}) =>
  apiClient.get("/admin/users", { params });

export const editUser = (id, data) => apiClient.put(`/admin/users/${id}`, data);
export const deleteUser = (id) => apiClient.delete(`/admin/users/${id}`);

export const deleteProject = (id) => {
  return apiClient.delete(`/user/projects/${id}`);
};
export const priceList = () => apiClient.get(`/admin/prices`);
export const updatePrice = (id, data) =>
  apiClient.put(`/admin/prices/${id}`, data);

//Admin APi
export const updateProjectPrice = (id, data) => {
  return apiClient.put(`/admin/project_price_update/${id}`, data);
};

export const getWebAppSetting = () => {
  return apiClient.get(`/admin/web_app_setting`);
};
export const updateWebAppSetting = (data) => {
  return apiClient.put(`/admin/web_app_setting`, data);
};
export const addUser = (data) => {
  return apiClient.post(`/admin/users/add`, data);
};

export const addAdmin = (data) => {
  return apiClient.post(`/admin`, data);
};

export const adminListApi = (params = {}) =>
  apiClient.get("/admin", { params });

export const editAdmin = (id, data) => apiClient.put(`/admin/${id}`, data);
export const deleteAdmin = (id) => apiClient.delete(`/admin/${id}`);

export const updateService = (id, data) => {
  return apiClient.put(`/admin/project_price_update/${id}`, data);
};
